import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ContextModel } from '@bayclubs/group-classes-employee-api';
import lodash from 'lodash';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ContextApiService } from './context.api.service';
import { LocationSortingService } from './location-sorting.service';

@Injectable({
    providedIn: 'root',
})
export class ManagementContextResolverService {
    private contextObservable: Observable<ContextModel>;

    constructor(private api: ContextApiService, private locationSorting: LocationSortingService) {
        this.contextObservable = this.api.get().pipe(
            shareReplay(1),
            map(context => {
                locationSorting.sortLocations(context.locations);
                return lodash.cloneDeep(context);
            })
        );
    }

    getContextObservable(): Observable<ContextModel> {
        return this.contextObservable.pipe(
            map(context => {
                return lodash.cloneDeep(context);
            })
        );
    }

    refreshContext(): Observable<ContextModel> {
        this.contextObservable = this.api.get().pipe(
            shareReplay(1),
            map(context => {
                this.locationSorting.sortLocations(context.locations);
                return lodash.cloneDeep(context);
            })
        );
        return this.contextObservable.pipe(
            map(context => {
                return lodash.cloneDeep(context);
            })
        );
    }

    // Resolver freezes the object in the snapshot data anyway
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): ContextModel | Observable<ContextModel> | Promise<ContextModel> {
        return this.contextObservable;
    }
}
